import { createStructuredSelector } from 'reselect';
import {
  TI_LIST, TI_LIST_SUCCESS, TI_LIST_ERROR, TI_PAGE_SET,
  TI_ADD, TI_ADD_SUCCESS, TI_ADD_ERROR,
  TI_SEARCH_CHANGE,
  TI_FILTER_TASK_STATUS, TI_FILTER_TASK_STATUS_SUCCESS,
  TI_FILTER_SUPPLIERS, TI_FILTER_SUPPLIERS_SUCCESS
} from '../../actions';

export const NAME = 'task_inspection';

export const TaskInspectionList = (page, num_page, orderBy, filters) => ({ type: TI_LIST, payload: { page, num_page, orderBy, filters } });
export const TaskInspectionListSuccess = (data) => ({ type: TI_LIST_SUCCESS, payload: data });
export const TaskInspectionListError = (error) => ({ type: TI_LIST_ERROR, payload: error });
export const TaskInspectionPageSet = (data) => ({ type: TI_PAGE_SET, payload: data });
export const TaskInspectionAdd = (data) => ({ type: TI_ADD, payload: data });
export const TaskInspectionAddSuccess = (data) => ({ type: TI_ADD_SUCCESS, payload: data });
export const TaskInspectionAddError = (error) => ({ type: TI_ADD_ERROR, payload: error });
export const TaskInspectionSearchChange = (data) => ({ type: TI_SEARCH_CHANGE, payload: data });
export const TaskInspectionFilterTaskStatus = () => ({ type: TI_FILTER_TASK_STATUS });
export const TaskInspectionFilterTaskStatusSuccess = (data) => ({ type: TI_FILTER_TASK_STATUS_SUCCESS, payload: data });
export const TaskInspectionFilterSuppliers = () => ({ type: TI_FILTER_SUPPLIERS });
export const TaskInspectionFilterSuppliersSuccess = (data) => ({ type: TI_FILTER_SUPPLIERS_SUCCESS, payload: data });

const task_inspection = (state) => state[NAME];
export const TaskInspectionSelector = createStructuredSelector({ task_inspection });
